<script lang="ts">
    import { onMount, onDestroy } from "svelte"

    let isVisible = $state(false)

    function hasCcConsent(): boolean {
        if (typeof document === "undefined") return false
        const allCookies = decodeURIComponent(document.cookie || "")
        const cookies = allCookies.split(";")
        // cc.js speichert die gewählten Tags in einem Cookie, das "ccTags" enthält
        return cookies.some((entry) => entry.includes("ccTags"))
    }

    function openCookieBar() {
        const w: any = window

        // Standardweg: vorhandene Bar einfach wieder anzeigen
        if (typeof w.ccShowBar === "function") {
            w.ccShowBar()
            return
        }

        // Falls aus irgendeinem Grund noch nichts initialisiert ist:
        if (typeof w.ccInit === "function") {
            w.ccInit()
            if (typeof w.ccShowBar === "function") {
                w.ccShowBar()
            }
            return
        }

        if (typeof w.ccBuildBar === "function") {
            w.ccBuildBar()
            if (typeof w.ccShowBar === "function") {
                w.ccShowBar()
            }
        }
    }

    const onCcAccept = () => {
        // Sobald eine Entscheidung getroffen wurde und die Cookiebar verschwindet,
        // kann das Fingerprint-Icon angezeigt werden.
        isVisible = true
    }

    onMount(() => {
        // Initial prüfen, ob bereits eine Entscheidung vorliegt
        isVisible = hasCcConsent()

        if (typeof window !== "undefined") {
            window.addEventListener("ccAccept", onCcAccept as EventListener)
        }
    })

    onDestroy(() => {
        if (typeof window !== "undefined") {
            window.removeEventListener("ccAccept", onCcAccept as EventListener)
        }
    })
</script>

{#if isVisible}
    <button
        type="button"
        class="cookie-fingerprint"
        aria-label="Cookie-Einstellungen öffnen"
        on:click={openCookieBar}
    >
        <img src="/media/fingerprint-icon.svg" alt="" aria-hidden="true" />
    </button>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    .cookie-fingerprint {
        position: fixed;
        bottom: 20px;
        left: 5px;
        z-index: 9999;
        transform: scale(0.5);
        transform-origin: center;
        height: 2.4rem;
        border: none;
        padding: 0;
        background: transparent;
        cursor: pointer;

        img {
            display: block;
            height: 100%;
            width: auto;
        }

        @media @tablet {
            bottom: 60px;
            left: 60px;
            transform: scale(1);
        }
    }
</style>
